/* eslint-disable */
import { FormControl, FormLabel, Grid } from "@chakra-ui/react";
import { Box, ListItemText } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CancelIcon from "@material-ui/icons/Cancel";
import { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { connectModal } from "redux-modal";
import {
  createToast,
  getAllToasts,
} from "../../utils/store/actions/toasts.actions";
import { B4FDate } from "../component-questionnaire/B4FDate/B4FDate";
import { B4FSelect } from "../component-questionnaire/B4FFields/B4FSelect";
import { B4FText } from "../component-questionnaire/B4FFields/B4FText";

class ModalCreateToast extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      toast: {
        startingDate: "",
        expirationDate: "",
        message: "",
        module: "",
      },
    };
  }

  static targetOptions = [
    { key: "B4DILIGENCE", label: "INVESTORS" },
    { key: "SUBSCRIPTIONS", label: "SUBSCRIPTIONS" },
  ];

  create = () => {
    this.props.createToast(this.state.toast).then(() => {
      this.props.getAllToasts();
      this.props.handleHide();
    });
  };

  render() {
    const { show, handleHide, t } = this.props;

    const closeBtn = (
      <IconButton className="close" onClick={handleHide}>
        <CancelIcon />
      </IconButton>
    );
    return (
      <div>
        <Modal
          isOpen={show}
          toggle={handleHide}
          backdrop={true}
          style={{
            backgroundColor: "#f5f6ff",
          }}
        >
          <ModalHeader
            toggle={handleHide}
            close={closeBtn}
            style={{
              backgroundColor: "#f5f6ff",
              fontWeight: "bolder",
            }}
          >
            {t("CREATE_BANDEAU")}
          </ModalHeader>
          <ModalBody
            style={{
              backgroundColor: "#f5f6ff",
            }}
          >
            <Grid
              templateRows="repeat(1, 1fr)"
              templateColumns="repeat(2, 1fr)"
              style={{
                backgroundColor: "white",
                padding: "5%",
                borderRadius: "5px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "start",
                }}
              >
                <ListItemText id="startingDate" primary={t("START_DATE")} />
                <B4FDate
                  id="startingDate"
                  key="startingDate"
                  value={`${this.state.startingDate}`}
                  visible={true}
                  language="FR"
                  isRequired={false}
                  onChange={(e: any) => {
                    this.setState({
                      toast: {
                        ...this.state.toast,
                        startingDate: new Date(Date.parse(e.target.value)),
                      },
                    });
                  }}
                  onUpdate={(e: any) => {
                    this.setState({
                      toast: {
                        ...this.state.toast,
                        startingDate: new Date(Date.parse(e.target.value)),
                      },
                    });
                  }}
                  isDisabled={false}
                  onBlur={(e: any) => {
                    this.setState({
                      toast: {
                        ...this.state.toast,
                        startingDate: new Date(Date.parse(e.target.value)),
                      },
                    });
                  }}
                  minDate=""
                />
                <ListItemText id="expirationDate" primary={t("END_DATE")} />
                <B4FDate
                  id="expirationDate"
                  key="expirationDate"
                  value={`${this.state.expirationDate}`}
                  language="FR"
                  visible={true}
                  isRequired={false}
                  onChange={(e: any) => {
                    this.setState({
                      toast: {
                        ...this.state.toast,
                        expirationDate: new Date(Date.parse(e.target.value)),
                      },
                    });
                  }}
                  onUpdate={(e: any) => {
                    this.setState({
                      toast: {
                        ...this.state.toast,
                        expirationDate: new Date(Date.parse(e.target.value)),
                      },
                    });
                  }}
                  isDisabled={false}
                  onBlur={(e: any) => {
                    this.setState({
                      toast: {
                        ...this.state.toast,
                        expirationDate: new Date(Date.parse(e.target.value)),
                      },
                    });
                  }}
                  minDate=""
                />
                <B4FSelect
                  label={t("MODULE")}
                  key="module"
                  id="module"
                  isRequired={false}
                  visible={true}
                  onChange={(e: any) => {
                    this.setState({
                      toast: {
                        ...this.state.toast,
                        module: ModalCreateToast.targetOptions.find(
                          (element) => element.key === e.value
                        )?.label,
                      },
                    });
                  }}
                  onBlur={() => {}}
                  value={this.state.module}
                  options={ModalCreateToast.targetOptions}
                />
                <FormControl id="message">
                  <FormLabel>{t("MESSAGE")}</FormLabel>
                  <B4FText
                    value={this.state.message || ""}
                    label=""
                    onChange={(e: any) => {
                      this.setState({
                        toast: {
                          ...this.state.toast,
                          message: e.value,
                        },
                      });
                    }}
                    onBlur={() => {}}
                    id="message"
                    key="textarea"
                    isDisabled={false}
                    isRequired={false}
                    visible={true}
                  />
                </FormControl>
              </Box>
            </Grid>
          </ModalBody>
          <ModalFooter
            style={{
              backgroundColor: "#f5f6ff",
              borderRadius: "10px",
            }}
          >
            <>
              <Button
                style={{
                  color: "rgb(99, 110, 149)",
                  border: "2px solid",
                  background: "none",
                }}
                onClick={handleHide}
              >
                {t("CANCEL")}
              </Button>
              <Button
                style={{ backgroundColor: "#ae0064", color: "white" }}
                disabled={
                  !(
                    this.state.toast.startDate !== "" &&
                    this.state.toast.expirationDate !== "" &&
                    this.state.toast.message !== "" &&
                    this.state.toast.module !== ""
                  )
                }
                onClick={this.create}
              >
                {t("CREATE")}
              </Button>
            </>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  ...state,
});
const mapDispatchToProps = {
  createToast,
  getAllToasts,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(connectModal({ name: "create_toast" })(ModalCreateToast)));
